/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { ApplicationRef, enableProdMode } from '@angular/core';
// import { enableDebugTools } from '@angular/platform-browser';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { StackTraceService } from './app/@core/service/stack-trace.service';

if (environment.production) {
  enableProdMode();
}

// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.error(err));

platformBrowserDynamic().bootstrapModule(AppModule)
  // .then(module => enableDebugTools(module.injector.get(ApplicationRef).components[0]))
  .catch(err => console.error(err));

if (environment.production) {
  (console as any).defaultError = console.error.bind(console);
  (console as any).defaultLog = console.log.bind(console);
  (console as any).errors = [];

  console.error = async function (...args: any[]) {
    // call original console.error
    (console as any).defaultError(...args);

    // create raw error stack
    const rawError = new Error();
    rawError.name = args[0]?.name || 'Error';
    rawError.message = args[0]?.message || args[0]?.toString();

    let mappedStack = rawError.stack || '';
    if (StackTraceService.instance) {
      mappedStack = await StackTraceService.instance.mapStackTrace(rawError);
    }

    const err = {
      time: new Date().toISOString(),
      type: 'err',
      data: args,
      stack: mappedStack,
    };
    (console as any).errors.push(err);
  };

  // console.error = function (...args: any[]) {
  //   (console as any).defaultError(...args);
  //   const rawError = new Error(args[0]?.message || args[0]?.toString());

  //   // kick off async mapping without blocking
  //   StackTraceService.instance?.mapStackTrace(rawError).then(mappedStack => {
  //     (console as any).errors.push({
  //       time: new Date().toISOString(),
  //       type: 'err',
  //       data: args,
  //       stack: mappedStack,
  //     });
  //     // optionally log the mapped stack
  //     console.log('Mapped stack:', mappedStack);
  //   });
  // };

  console.log = function(){
      // default &  console.log()
      (console as any).defaultLog.apply(console, arguments);
      // new & array data
      const log: any = {
        time: new Date().toISOString(),
        type: 'log',
        data: Array.from(arguments),
      };
      (console as any).errors.push(log);
  }
}
